<template>
    <!--弹窗-->
    <el-dialog
        width="80%"
        :title="title"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" :inline="true">

            <el-form-item label="货件单号:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.shipment_number" placeholder="请输入货件单号"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="货件名称:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.shipment_name" placeholder="请输入货件名称"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="店铺:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.shop" placeholder="请输入店铺"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Asin:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.asin" placeholder="请输入Asin"
                          size="mini"></el-input>
            </el-form-item>
            <el-form-item label="负责人:" prop="name">
                <el-input style="width: 150px;" clearable v-model="formData.supervisor" placeholder="请输入负责人"
                          size="mini"></el-input>
            </el-form-item>

            <el-button type="primary" @click="queryData()" size="mini" style="margin-top: 7px">查询</el-button>

        </el-form>

        <el-table :row-key="getRowKeys" v-loading="loading" :data="list" height="70vh" size="mini" ref="multipleTable"
                  class="table_content mini_div" border style="width: 100%;">
            <el-table-column label="ID" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="货件单号" width="130" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shipment_number }}</div>
                </template>
            </el-table-column>
            <el-table-column label="货件名称" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shipment_name }}</div>
                </template>
            </el-table-column>

            <el-table-column label="货件状态" width="120" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shipment_status }}</div>
                </template>
            </el-table-column>
            <el-table-column label="店铺" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shop }}</div>
                </template>
            </el-table-column>
            <el-table-column label="asin" width="110" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.asin }}</div>
                </template>
            </el-table-column>
            <el-table-column label="品名" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.product_name }}</div>
                </template>
            </el-table-column>
            <el-table-column label="申报量" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.declared_amount }}</div>
                </template>
            </el-table-column>

            <el-table-column label="已发货" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shipped_amount }}</div>
                </template>
            </el-table-column>
            <el-table-column label="签收量" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.signatures_amount }}</div>
                </template>
            </el-table-column>

            <el-table-column label="负责人" width="100" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.supervisor }}</div>
                </template>
            </el-table-column>


        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>

        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button
            >
        </el-row>

        <!--        <chooseRootCategory :visible="addRootCategoryModal" @chooseInfoFunc="chooseInfoFunc"-->
        <!--                            @close-callback="addRootCategoryModal=false"></chooseRootCategory>-->
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    // import chooseRootCategory from './chooseRootCategory.vue'
    import {keepa_keepa_root_category_add} from '@/api/advAnalys/advAnalys.js'

    export default {
        // components: {chooseRootCategory},
        data() {
            return {
                copyInfo: {},
                visible: false,
                addRootCategoryModal: false,
                loading: false,
                options: [],
                list: [],
                rules: {},
                formData: {
                    shipment_number: '',
                    shipment_name: '',
                    shop: '',
                    asin: '',
                    supervisor: '',
                },
                chooseInfo: {},
                query: {
                    page: 1,
                    limit: 20
                },
                total: 0,
            }
        },
        props: {
            title: {
                type: String,
                default: ''
            },
        },
        methods: {
            queryData() {
                this.query.page = 1
                this.getCategoryList()
            },
            handleCurrentChange(val) {
                this.query.page = val
                this.getCategoryList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getCategoryList()
            },
            showModal(data) {
                this.visible = true
                this.copyInfo = data
                this.loading = true
                this.getCategoryList()
            },
            getRowKeys(row) {
                return row.catId
            },
            chooseFunc(data) {
                this.$confirm('确认添加此根目录吗?', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.chooseInfo = data
                    this.addRootCategory()
                })
            },
            chooseInfoFunc(data) {
                this.chooseInfo = data
            },
            getCategoryList() {
                this.loading = true
                api.logistics_index_detail({list_id: this.copyInfo.id, ...this.formData, ...this.query}).then(res => {
                    if (res.code === 0) {
                        this.list = res.data.list || []
                        this.total = res.data.total || 0

                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            // 保存信息
            submitForm() {
                if (this.chooseInfo == null) {
                    this.$message.info('请选择一个类目')
                    return
                }
                this.$emit('chooseInfo', this.chooseInfo)
            },
            // 关闭弹窗
            handleClose(isshow = false) {
                this.formData = {
                    shipment_number: '',
                    shipment_name: '',
                    shop: '',
                    asin: '',
                    supervisor: '',
                }
                this.list = []
                this.loading = false
                this.visible = false
                this.$emit('close-callback', isshow)
            },
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .content {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #cecfd1;
        font-size: 12px;
        color: #000;

        .shu {
            border-right: 1px solid #cecfd1;
        }

        .content-div {
            width: 50%;
            padding: 25px 20px;
        }

        .content-buttom {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #cecfd1;
            padding-bottom: 8px;
            margin-bottom: 10px;
        }

        .content-buttom-txet {
            color: rgb(57, 187, 252);
            cursor: pointer;
        }

        .content-data {
            width: 100%;
            height: 230px;
            overflow: auto;

            .content-list {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px 0;

                .cha {
                    cursor: pointer;
                    font-size: 15px;
                    color: rgb(158, 192, 209);
                    margin: 0 10px 0 12px;
                }
            }
        }

        /deep/ .content-data::-webkit-scrollbar {
            width: 3px;
            height: 5px;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-track-piece {
            background-color: #ffff;
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
            height: 5px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }

        /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
            width: 3px;
            background-color: rgba(144, 147, 153, 0.5);
            border-radius: 15px;
            -webkit-border-radius: 15px;
        }
    }

    .media-txt {
        font-size: 15px;
        color: #6a6c6f;
        font-weight: 600;
        margin-bottom: 8px;
    }

    /deep/ .el-dialog__body {
        padding: 0px 20px 20px 20px !important;
    }

    /deep/ .el-form-item {
        margin-bottom: 12px !important;
    }
</style>
